import { render, staticRenderFns } from "./PagarComprobante.vue?vue&type=template&id=6b87b6fa"
import script from "./PagarComprobante.vue?vue&type=script&lang=js"
export * from "./PagarComprobante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports